import API from "@constants/API";

const BASE_URL = "https://api.dev.daily.co.id/summary/v2/dashboard-summaries";

export const getDashboardDataApi = async () => {
  const response = await API.HTTP.get(BASE_URL);
  return response.data;
};
